/**
 * @generated SignedSource<<6979f5a99209ba57eb8c498df346fdf3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DashboardTemplate_query$data = {
  readonly company: {
    readonly id: string;
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly me: {
    readonly _id: string;
    readonly email: string | null | undefined;
    readonly id: string;
    readonly name: string;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"Menu_query" | "Sidebar_query">;
  readonly " $fragmentType": "DashboardTemplate_query";
};
export type DashboardTemplate_query$key = {
  readonly " $data"?: DashboardTemplate_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"DashboardTemplate_query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DashboardTemplate_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Candidate",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "_id",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "company",
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "companyDomainName",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Menu_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Sidebar_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "fa0ae2ec94c9e2afd1b4ad5c46ab2325";

export default node;
